import React, { useEffect, useState } from 'react';
import axiosInstance from '../../../utils/axiosSetup.js';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Swal from 'sweetalert2';
import { closeModal } from '../../../action/modalbehaviour.js';


const EditPermission = ({permId, list }) => {
    const [permData, setPermData] = useState(null);

    const fetchPermission = async (Id) => {      
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/permission/${Id}`)
            .then(response => {
                setPermData(response.data.data);
            })
            .catch(error => {
                console.log(error);
                setPermData([]); 
            });
    }

    useEffect(() => {
        if (permId) {
            fetchPermission(permId);
        }
    },[permId]);

    // VALIDATION RULES
    const schema = Yup.object().shape({
        name: Yup.string().required(),
    });

    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        mode: 'all',
        resolver: yupResolver(schema)
    });

    useEffect(() => {
        if (permData) {
            reset(permData);
        }
    }, [permData, reset]);

    const onSubmit = async (data) => {
        axiosInstance.post(`${process.env.REACT_APP_API_URL}/permission/${permId}`, data)
            .then(response => {
                Swal.fire({icon:"success", text:response.data.message});
                closeModal(`edit_permission_${permId}`);
                list();
            })
            .catch(({response:{data}})=>{
                Swal.fire({text:data.message, icon:"error"});
            });
    }

    if (!permId || !permData) {
        return null;
    }

    return (
        <div id={`edit_permission_${permId}`}  className="modal custom-modal fade" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Edit Permission</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Permission Name <span className="text-danger">*</span></label>
                                        <input className="form-control" type="text" defaultValue={permData.name} {...register('name')} />
                                        <div className="text-sm text-danger">
                                            {errors.name && <p>{errors.name.message}</p>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="submit-section">
                                <button type="submit" className="btn btn-primary submit-btn">SUBMIT</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EditPermission